// /subscription used to render a blank page after the original component
// was stubbed out. Serve the same checkout used by /subscription-plans.
export { default } from "./PlanSubscriptions";
